import React, { Component } from 'react';
import EnhancedTable from '../../components/table';
import Config from '../../config';
import { Grid, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../../helpers';
import { SubscriptionStatus } from './subscription';
import Moment from 'react-moment';
import { InvoiceStatus } from './subscription_invoice';

class BillingDashboard extends Component {
    render(){
        let subscriptionConfig = {
            url: Config.api + '/odata/Company/Subscriptions',
            columns: [
                { id: "Id", filterable: true, label: 'ID' },
                { id: "Currency", hidden: true },
                { id: "Plan", filterable: true, label: 'Type' },
                { id: "Status", filterable: true, label: 'Status', width: '20em', template: (value: string) => <SubscriptionStatus status={value}/> },
                { id: 'Amount', filterable: true, sortable: true, label: 'Cost', width: '20em', template: (value: number, row: { Currency?: string }) => formatCurrency(value, row.Currency) },
                { command: 'commands', stopPropagation: 'true', width: '13em', template: (value: unknown, row: { Id: string | number }) => (
                    <><Button size='small' variant='outlined' component={Link} to={`/billing/subscription?sub=${row.Id}`}>View</Button></>
                )}
            ],
            filter: { logic: 'and', filters: [{field: 'Status', operator: 'neq', value: 'Cancelled', system: true}] },
            order: 'asc',
            orderBy: 'Id',
            keyField: 'Id',
            pageSize: 10,
            pageSizes: [10, 20, 50],
            title: 'Subscriptions'
        };
        let invoiceConfig = {
            columns: [
              { id: 'Id', label: 'ID', width: '12em', hidden: true },
              { id: 'Currency', label: 'Currency', width: '12em', hidden: true },
              { id: 'Number', label: 'Invoice Number', filterable: true },
              { id: 'Status', label: 'Status', filterable: true, template: (value: string) => <InvoiceStatus status={value}/> },
              { id: 'InvoiceDate', type:'date', filterable: true, sortable: true, label: 'Inoice Date', template: (value: string) => (<Moment format='MM/DD/YYYY'>{value}</Moment>), width: '15em' },
              { id: 'DueDate', type:'date', filterable: true, sortable: true, label: 'Due Date', template: (value: string) => value ? (<Moment format='MM/DD/YYYY'>{value}</Moment>) : '', width: '15em' },
              { id: 'Total', filterable: true, sortable: true, label: 'Total', width: '20em', template: (value: number, row: { Currency?: string }) => formatCurrency(value, row.Currency) },
              { id: 'Balance', filterable: true, sortable: true, label: 'Balance', width: '20em', template: (value: number, row: { Currency?: string }) => formatCurrency(value, row.Currency) },
              { command: 'commands', width: '10em', stopPropagation: 'true', template: (value: unknown, row: { Id: string | number }) => {return (
                  <><Button size='small' variant='outlined' component={Link} to={`/billing/subscription/invoice?id=${row.Id}`}>View</Button></>
              );}}
          ],
          url: Config.api + `/odata/Company/Invoices`,
          order: 'desc',
          orderBy: 'Id',
          keyField: 'Id',
          pageSize: 10,
          pageSizes: [10, 20, 50],
          title: 'Invoices',
        };
        return (<Grid container spacing={2}>
            <Grid size={12}>
                <EnhancedTable config={subscriptionConfig}/>
            </Grid>
            <Grid size={12}>
                <EnhancedTable config={invoiceConfig}/>
            </Grid>
            </Grid>);
    }
}

export default BillingDashboard;
